// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__ey4Ty","Mentions":"Footer_Mentions__ppeNp"};